import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue'
import { $vfm } from 'vue-final-modal'
import { vacancyDetailResource } from '@/services/vacancy.service'


export default /*@__PURE__*/_defineComponent({
  __name: 'Details',
  props: {
    slug: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props

const loading = ref(true)
const vacancy = ref<any>(null)

// Коди з адмінки → ключ для $t() (український текст як ключ, як у решті сайту)
const WORK_FORMAT_LABELS: Record<string, string> = {
  office: 'Офіс',
  remote: 'Віддалено',
  hybrid: 'Гібрид',
}
const EMPLOYMENT_TYPE_LABELS: Record<string, string> = {
  full_time: 'Повна зайнятість',
  part_time: 'Часткова зайнятість',
}

const workFormatLabel = computed(() => {
  const code = vacancy.value?.workFormat ?? vacancy.value?.work_format ?? ''
  return WORK_FORMAT_LABELS[code] ?? code
})

const employmentTypeLabel = computed(() => {
  const code = vacancy.value?.employmentType ?? vacancy.value?.employment_type ?? ''
  return EMPLOYMENT_TYPE_LABELS[code] ?? code
})

const salaryText = computed(() => {
  const v = vacancy.value
  if (!v) return ''
  const from = v.salaryFrom ?? v.salary_from
  const to = v.salaryTo ?? v.salary_to
  const curr = v.currency?.label || 'грн'
  if (!from && !to) return ''
  if (!to) return `${formatNum(from)} ${curr}`
  return `${formatNum(from)} - ${formatNum(to)} ${curr}`
})

function formatNum(n: number | null): string {
  if (n == null) return ''
  return n.toLocaleString('uk-UA')
}

const shareUrl = computed(() => {
  if (typeof window === 'undefined') return ''
  return encodeURIComponent(window.location.href)
})

const shareText = computed(() => {
  return encodeURIComponent(vacancy.value?.title || document.title)
})

const shareTelegram = computed(() => {
  return `https://t.me/share/url?url=${shareUrl.value}&text=${shareText.value}`
})

const shareWhatsApp = computed(() => {
  return `https://wa.me/?text=${shareText.value}%20${shareUrl.value}`
})

const shareFacebook = computed(() => {
  return `https://www.facebook.com/sharer/sharer.php?u=${shareUrl.value}`
})

function openResponseForm() {
  $vfm.show({ component: 'Vacancies/VacancyModalContainer' }, {
    classes: ['modal--size_xl'],
    info: { vacancy: vacancy.value },
  })
}

onMounted(async () => {
  try {
    const res = await vacancyDetailResource.execute({ slug: props.slug })
    vacancy.value = res?.data?.item ?? res?.data ?? res ?? null
  } catch (e) {
    console.error('Vacancy detail load error:', e)
    vacancy.value = null
  } finally {
    loading.value = false
  }
})

const __returned__ = { props, loading, vacancy, WORK_FORMAT_LABELS, EMPLOYMENT_TYPE_LABELS, workFormatLabel, employmentTypeLabel, salaryText, formatNum, shareUrl, shareText, shareTelegram, shareWhatsApp, shareFacebook, openResponseForm, ref, computed, onMounted, get $vfm() { return $vfm }, get vacancyDetailResource() { return vacancyDetailResource } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})